export const goodsTableColums = [
  {
    title: '货品序号',
    dataIndex: 'index',
    key: 'index',
    width: 100,
    customRender: (text, record, index) => `${index + 1}`
  },
  {
    title: '货品',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 200
  },
  {
    title: '计划量',
    dataIndex: 'goodsInfo',
    key: 'goodsInfo',
    scopedSlots: { customRender: 'goosInfo' },
    width: 300
  },
  {
    title: '温区',
    dataIndex: 'temperatureZone',
    key: 'temperatureZone',
    scopedSlots: { customRender: 'temperatureZone' },
    width: 200
  },
  {
    title: '货值（元）',
    dataIndex: 'skuValue',
    key: 'skuValue',
    width: 200
  },
]

export const orderAmount = [
    {
      title: '类型',
      dataIndex: 'costType',
      key: 'costType',
    },
    // {
    //   title: '子类型',
    //   dataIndex: 'subType',
    //   key: 'subType',
    // },
    {
      title: '金额（元）',
      dataIndex: 'cost',
      key: 'cost',
    },
]

export const CHANGETYPE = {
  CREATE: '新增替换站点信息',
  UPDATE: '更新原站点信息'
}

export const FLOWSTATUS = {
  FAIL: '提交失败',
  TO_BE_APPROVAL: '待审核',
  REJECTED: '审核拒绝',
  APPROVAL: '审核通过',
  APPROVAL_TERMINATION: '审核终止'
}